export function useGetImportOriginsChartData(data) {

    const config = {

        type: 'bar',
        data: {
            labels: data.map(each => each.label),
            datasets: [{
                label: 'Import Origins',
                data: data.map(each => each.value),
                borderWidth: 1,
                backgroundColor: [
                    'rgb(184,164,112)',
                    'rgb(89,146,99)',
                    'rgba(9,15,71,0.8)',
                    'rgb(233,202,50)',
                    'rgb(155,61,33,0.8)',
                    'rgb(131,150,118,0.8)'
                ],
            }],

        },
        options: {
            plugins: {
                legend: {
                    display: false,
                    position: 'top',
                    labels: {
                        boxWidth: 13,
                    }
                },

            },
            responsive: true,
            hoverOffset: 15,
            scales: {},
            layout: {
                padding: 20,
                font: {
                    family: 'roboto'
                }
            }
        }

    }

    return config;

}
